import React from 'react';
import logo from '../../../assets/img/logo.png';
import NavigationItem from './NavigationItem/NavigationItem';

const NavigationItems = () => {
    return (
        <nav className = "nav">
            <div className="nav__container">
                <figure className="nav__logo-box">
                    <img src={logo} alt="Logo" className="nav__logo" data-aos = "zoom-in"/>
                </figure>
                <ul className="nav__list">
                    <NavigationItem exact = {true} link = "/" delay = "300">Home</NavigationItem>
                    <NavigationItem  link = "/projects" delay = "200">Projects</NavigationItem>
                    <NavigationItem  link = "/contact" delay = "100" >Contact</NavigationItem>
                    <NavigationItem  link = "/about" >About</NavigationItem>
                </ul>
            </div>
        </nav>
    );
};

export default NavigationItems;